import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/pc/home/Home.vue'
import Sound from '../views/pc/sound/Sound.vue'
import ShowVideo from '../views/pc/video/ShowVideo.vue'
import ShowPicture from '@/views/pc/picture/picture.vue'
import Music from '../views/pc/music/Music.vue'
import Login from "../views/pc/common/login.vue";
import MusicList from '../views/pc/music/MusicList.vue'
import More from '@/views/pc/more/More.vue'
import VideoContent from '@/views/pc/video/VideoContent.vue'
import MemberList from '@/views/pc/member/MemberList.vue'
import Member from '@/views/pc/member/MemberContent.vue'
import VrGuide from '@/views/pc/vr/VrGuide.vue'

import HomeMobile from '@/views/mobile/home/Home.vue'
import ShowVideoMobile from '@/views/mobile/video/ShowVideo.vue'
import ShowPictureMobile from '@/views/mobile/picture/picture.vue'
import MusicListMobile from '@/views/mobile/music/MusicList.vue'
import MusicMobile from '@/views/mobile/music/Music.vue'
import SoundMobile from '@/views/mobile/sound/Sound.vue'
import MoreMobile from '@/views/mobile/more/More.vue'
import VideoContentMobile from '@/views/mobile/video/VideoContent.vue'
import MemberListMobile from '@/views/mobile/member/MemberList.vue'
import MemberMobile from '@/views/mobile/member/MemberContent.vue'
import VrGuideMobile from '@/views/mobile/vr/VrGuide.vue'

Vue.use(VueRouter)

//默认路由
export const routes = [
  {
    path: '/',
    redirect: '/home'
  },
];
//pc端的路由
export const pcRoutes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/sound',
    name: 'Sound',
    component: Sound
  },
  {
    path: '/show-video',
    name: 'ShowVideo',
    component: ShowVideo
  },
  {
    path: '/show-picture',
    name: 'ShowPicture',
    component: ShowPicture
  },
  {
    path: '/video-content',
    name: 'VideoContent',
    component: VideoContent
  },
  {
    path: '/music/list',
    name: 'MusicList',
    component: MusicList
  },
  {
    path: '/music',
    name: 'Music',
    component: Music
  },
  {
    path: '/more',
    name: 'More',
    component: More
  },{
    path: '/member/list',
    name: 'MemberList',
    component: MemberList
  },
  {
    path: '/member',
    name: 'MemberContent',
    component: Member
  },
  {
    path: '/vr-guide',
    name: 'VrGuide',
    component: VrGuide
  },
];
//移动端设备路由
export const mobileRoutes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: HomeMobile
  },
  {
    path: '/sound',
    name: 'Sound',
    component: SoundMobile
  },
  {
    path: '/show-video',
    name: 'ShowVideo',
    component: ShowVideoMobile
  },
  {
    path: '/show-picture',
    name: 'ShowPicture',
    component: ShowPictureMobile
  },
  {
    path: '/video-content',
    name: 'VideoContentMobile',
    component: VideoContentMobile
  },
  {
    path: '/music/list',
    name: 'MusicList',
    component: MusicListMobile
  },
  {
    path: '/music',
    name: 'Music',
    component: MusicMobile
  },
  {
    path: '/more',
    name: 'MoreMobile',
    component: MoreMobile
  },{
    path: '/member/list',
    name: 'MemberList',
    component: MemberListMobile
  },
  {
    path: '/member',
    name: 'MemberContent',
    component: MemberMobile
  },
  {
    path: '/vr-guide',
    name: 'VrGuide',
    component: VrGuideMobile
  },
];

const createRouter = () => new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  mode: "hash",
  // mode: "history",
  base: process.env.BASE_URL,
  // base: 'http://localhost:8080/renren-fast/diyun',
  routes: routes,
});

const router = createRouter();

//全局前置守卫
router.beforeEach((to, from, next) => {
  console.log("beforeEach to:", to);
  //console.log("beforeEach from", from);
  if (to.path === "/" || to.path === '/home') {
      sessionStorage["quit"] = 1;
  } else {
      sessionStorage["quit"] = 0;

  }
  if (to.path != "/college/tabbar" && to.path != "/high/tabbar") {

      if (window.plus) {
          // plus.navigator.setStatusBarBackground('#ffffff');//白色背景
          // plus.navigator.setStatusBarStyle("dark");//黑色字体
          // console.log(this.show);

      } else {
          // console.log(this.show);

          // document.addEventListener("plusready", function () {
          //     plus.navigator.setStatusBarBackground('#ffffff');
          //     plus.navigator.setStatusBarStyle('dark');
          // }, false);
      }
  }
  console.log(sessionStorage);
  next();
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.match = newRouter.match; // reset router
}


export default router
